// extracted by css-extract-rspack-plugin
export default {"instructions":"Block-module__instructions___ER0cE"};